export default __webpack_public_path__ + "static/media/down-chevron.26c29e1b.svg";